import { CircleExclamationSolid } from '@allocab/allocab-icons';
import { useRef } from 'react';

import { Dialog, Props as DialogProps, DialogTitle } from './Dialog';
import { t } from '../../services/translation/translation';
import { DangerButton } from '../button/DangerButton';
import { SecondaryButton } from '../button/SecondaryButton';

type Props = DialogProps & {
  onConfirm: () => void;
  confirmLabel: string;
  title: string;
  message: string;
};

export const AlertDialog = ({ onConfirm, confirmLabel, title, message, ...rest }: Props) => {
  const cancelButtonRef = useRef(null);

  return (
    <Dialog {...rest} initialFocus={cancelButtonRef}>
      <div className="sm:flex sm:items-start">
        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-error sm:mx-0 sm:h-10 sm:w-10 bg-opacity-25">
          <CircleExclamationSolid className="fill-error" width={20} height={20} />
        </div>
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <DialogTitle as="h3" className="text-base font-semibold leading-6">
            {title}
          </DialogTitle>
          <div className="mt-2">
            <p className="text-sm text-text_secondary">{message}</p>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
        <DangerButton onClick={onConfirm}>{confirmLabel}</DangerButton>
        <SecondaryButton onClick={rest.onClose} buttonRef={cancelButtonRef}>
          {t('common.cancel')}
        </SecondaryButton>
      </div>
    </Dialog>
  );
};
